import React from 'react';

type Props = {
  className?: string;
  color?: string;
};

const BackToTopIcon: React.FC<Props> = ({ className, color = '#000000' }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 360 360" fill="none">
    <path
      fill="#FFFFFF"
      stroke={color}
      strokeWidth="4"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M314,349H46c-19.9,0-36-16.1-36-36V45C10,25.1,26.1,9,46,9H314c19.9,0,36,16.1,36,36V313C350,332.9,333.9,349,314,349z"
    />
    <g fill={color}>
      <path d="M120.5,173c2.2,0,4.2,0.4,5.9,1.3c1.7,0.9,3.1,2.1,4,3.7c1,1.6,1.5,3.3,1.5,5.3c0,4.2-2,7.3-5.9,9.2c2.3,1,4.2,2.5,5.5,4.4c1.3,1.9,2,3.9,2,6.2c0,2.2-0.5,4.1-1.6,5.9c-1,1.7-2.5,3.1-4.4,4s-4,1.5-6.4,1.5H102V173H120.5z M125.8,189c1.5-1.4,2.3-3.1,2.3-5.2s-0.8-3.8-2.3-5.2c-1.6-1.3-3.6-2-6-2h-13.8v14.4h14C122.3,191.1,124.2,190.4,125.8,189z M127.1,208.7c1.7-1.6,2.6-3.5,2.6-5.9c0-2.4-0.9-4.3-2.6-5.9c-1.7-1.5-3.9-2.3-6.6-2.3h-14.5V211h14.5C123.1,211,125.3,210.2,127.1,208.7z" />
      <path d="M175.2,214.6l-4.3-9.8h-23.8l-4.3,9.8h-4.2l18.3-41.5h4.2l18.3,41.5H175.2z M148.8,201h20.4L159,177.8L148.8,201z" />
      <path d="M193.6,212.4c-3.3-2-5.9-4.6-7.8-7.9c-1.9-3.3-2.9-6.9-2.9-10.7c0-3.8,1-7.4,2.9-10.7c1.9-3.3,4.5-5.9,7.8-7.9c3.3-2,6.8-2.9,10.5-2.9c2.8,0,5.5,0.6,8.1,1.7c2.6,1.1,4.9,2.7,6.8,4.7l-2.7,2.7c-1.6-1.7-3.5-3-5.6-4c-2.1-0.9-4.3-1.4-6.7-1.4c-3.1,0-6,0.8-8.6,2.4c-2.7,1.6-4.8,3.8-6.3,6.5c-1.6,2.7-2.4,5.7-2.4,8.9c0,3.2,0.8,6.1,2.4,8.9s3.7,4.9,6.3,6.6c2.7,1.6,5.5,2.4,8.6,2.4c2.3,0,4.6-0.5,6.7-1.5s4-2.3,5.6-4l2.7,2.7c-2,2-4.3,3.5-6.8,4.7c-2.6,1.1-5.3,1.7-8.1,1.7C200.4,215.3,196.9,214.3,193.6,212.4z" />
      <path d="M227.6,173h3.9v24l21.9-24h5.1L241.2,192l18.6,22.6h-5l-16.3-19.9l-7,7.5v12.4h-3.9V173z" />
      <path d="M82.9,244.7H68.5V241h32.6v3.7H86.8v37.8h-3.9V244.7z" />
      <path d="M115.7,280.3c-3.3-2-5.9-4.6-7.8-7.9c-1.9-3.3-2.9-6.9-2.9-10.7c0-3.8,1-7.4,2.9-10.7c1.9-3.3,4.5-5.9,7.8-7.9c3.3-2,6.8-2.9,10.5-2.9c3.8,0,7.3,1,10.5,2.9c3.2,2,5.8,4.6,7.8,7.9c1.9,3.3,2.9,6.8,2.9,10.7c0,3.8-1,7.4-2.9,10.7c-1.9,3.3-4.5,5.9-7.8,7.9c-3.2,2-6.8,2.9-10.5,2.9C122.5,283.3,119,282.3,115.7,280.3z M134.9,277.2c2.7-1.6,4.8-3.8,6.3-6.6s2.4-5.7,2.4-8.9c0-3.1-0.8-6.1-2.4-8.8c-1.6-2.7-3.7-4.9-6.3-6.6c-2.7-1.6-5.5-2.4-8.6-2.4c-3.1,0-5.9,0.8-8.6,2.4c-2.7,1.6-4.8,3.8-6.4,6.6c-1.6,2.7-2.4,5.7-2.4,8.8c0,3.2,0.8,6.1,2.4,8.9c1.6,2.7,3.7,4.9,6.4,6.6s5.5,2.4,8.6,2.4C129.3,279.6,132.2,278.8,134.9,277.2z" />
      <path d="M185.8,244.7h-14.4V241h32.6v3.7h-14.4v37.8h-3.9V244.7z" />
      <path d="M218.6,280.3c-3.3-2-5.9-4.6-7.8-7.9c-1.9-3.3-2.9-6.9-2.9-10.7c0-3.8,1-7.4,2.9-10.7c1.9-3.3,4.5-5.9,7.8-7.9c3.3-2,6.8-2.9,10.5-2.9c3.8,0,7.3,1,10.5,2.9c3.2,2,5.8,4.6,7.8,7.9c1.9,3.3,2.9,6.8,2.9,10.7c0,3.8-1,7.4-2.9,10.7c-1.9,3.3-4.5,5.9-7.8,7.9c-3.2,2-6.8,2.9-10.5,2.9C225.4,283.3,221.9,282.3,218.6,280.3z M237.8,277.2c2.7-1.6,4.8-3.8,6.3-6.6s2.4-5.7,2.4-8.9c0-3.1-0.8-6.1-2.4-8.8c-1.6-2.7-3.7-4.9-6.3-6.6c-2.7-1.6-5.5-2.4-8.6-2.4c-3.1,0-5.9,0.8-8.6,2.4c-2.7,1.6-4.8,3.8-6.4,6.6c-1.6,2.7-2.4,5.7-2.4,8.8c0,3.2,0.8,6.1,2.4,8.9c1.6,2.7,3.7,4.9,6.4,6.6s5.5,2.4,8.6,2.4C232.2,279.6,235.1,278.8,237.8,277.2z" />
      <path d="M276.3,241c2.8,0,5.4,0.6,7.6,1.7s4.1,2.7,5.4,4.7c1.3,2,2,4.2,2,6.7s-0.7,4.7-2,6.7c-1.3,2-3.1,3.5-5.4,4.7c-2.3,1.1-4.8,1.7-7.6,1.7h-13.2v15.4h-3.9V241H276.3z M284.2,261c2.2-1.7,3.2-4,3.2-6.8c0-2.9-1.1-5.1-3.2-6.9c-2.2-1.7-5-2.6-8.6-2.6h-12.4v18.8h12.4C279.2,263.5,282,262.7,284.2,261z" />
    </g>
    <g>
      <line
        fill="none"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        x1="69.3"
        y1="138.7"
        x2="179.9"
        y2="54.2"
      />
      <line
        fill="none"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        x1="290.7"
        y1="138.7"
        x2="180.1"
        y2="54.2"
      />
    </g>
  </svg>
);

export default BackToTopIcon;
